/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Totalitemslabel2Inputs */

const id_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total item`)
};

const ms_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah item`)
};

const da_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlede items`)
};

const de_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items insgesamt`)
};

const en_us2_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total items`)
};

const es_es2_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de ítems`)
};

const es_mx2_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de ítems`)
};

const fil_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kabuuang item`)
};

const fr_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total des items`)
};

const it_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale articoli`)
};

const hu_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Összes elem`)
};

const nl_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totaal items`)
};

const no_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalt elementer`)
};

const pl_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łączna liczba elementów`)
};

const pt_br2_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de itens`)
};

const pt_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de itens`)
};

const ro_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total elemente`)
};

const fi_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohteita yhteensä`)
};

const sv_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalt antal objekt`)
};

const vi_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng số mục`)
};

const tr_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toplam öğe`)
};

const cs_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celkem položek`)
};

const bg_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общо обекти`)
};

const ru_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всего объектов`)
};

const uk_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усього елементів`)
};

const ar_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجمالي العناصر`)
};

const hi_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुल आइटम`)
};

const th_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการทั้งหมด`)
};

const ja_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイテム総数`)
};

const zh_cn2_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品总数`)
};

const zh_hant1_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品總數`)
};

const ko_sandboxes_totalitemslabel2 = /** @type {(inputs: Sandboxes_Totalitemslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`총 아이템`)
};

/**
* | output |
* | --- |
* | "Total items" |
*
* @param {Sandboxes_Totalitemslabel2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_totalitemslabel2 = /** @type {((inputs?: Sandboxes_Totalitemslabel2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Totalitemslabel2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_totalitemslabel2(inputs)
	if (locale === "ms") return ms_sandboxes_totalitemslabel2(inputs)
	if (locale === "da") return da_sandboxes_totalitemslabel2(inputs)
	if (locale === "de") return de_sandboxes_totalitemslabel2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_totalitemslabel2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_totalitemslabel2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_totalitemslabel2(inputs)
	if (locale === "fil") return fil_sandboxes_totalitemslabel2(inputs)
	if (locale === "fr") return fr_sandboxes_totalitemslabel2(inputs)
	if (locale === "it") return it_sandboxes_totalitemslabel2(inputs)
	if (locale === "hu") return hu_sandboxes_totalitemslabel2(inputs)
	if (locale === "nl") return nl_sandboxes_totalitemslabel2(inputs)
	if (locale === "no") return no_sandboxes_totalitemslabel2(inputs)
	if (locale === "pl") return pl_sandboxes_totalitemslabel2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_totalitemslabel2(inputs)
	if (locale === "pt") return pt_sandboxes_totalitemslabel2(inputs)
	if (locale === "ro") return ro_sandboxes_totalitemslabel2(inputs)
	if (locale === "fi") return fi_sandboxes_totalitemslabel2(inputs)
	if (locale === "sv") return sv_sandboxes_totalitemslabel2(inputs)
	if (locale === "vi") return vi_sandboxes_totalitemslabel2(inputs)
	if (locale === "tr") return tr_sandboxes_totalitemslabel2(inputs)
	if (locale === "cs") return cs_sandboxes_totalitemslabel2(inputs)
	if (locale === "bg") return bg_sandboxes_totalitemslabel2(inputs)
	if (locale === "ru") return ru_sandboxes_totalitemslabel2(inputs)
	if (locale === "uk") return uk_sandboxes_totalitemslabel2(inputs)
	if (locale === "ar") return ar_sandboxes_totalitemslabel2(inputs)
	if (locale === "hi") return hi_sandboxes_totalitemslabel2(inputs)
	if (locale === "th") return th_sandboxes_totalitemslabel2(inputs)
	if (locale === "ja") return ja_sandboxes_totalitemslabel2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_totalitemslabel2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_totalitemslabel2(inputs)
	return ko_sandboxes_totalitemslabel2(inputs)
});
export { sandboxes_totalitemslabel2 as "sandboxes.totalItemsLabel" }